import React from "react";
import EnrolmentForm from "./EnrolmentForm/EnrolmentForm";
import { connect } from "react-redux";
import moment from "moment";
import { Elements } from "@stripe/react-stripe-js";
import Modal from "react-bootstrap/Modal";
import LoginForm from "../../components/LoginForm/LoginForm";
import baseApi from "../../../api/baseApi";
import { loadStripe } from "@stripe/stripe-js";
import {
  CHILD_FIELDS,
  parseLessonsNames,
  selectedClassHelper,
} from "../../Common/enrolmentHelpers";

class SecondEnrolmentPage extends React.Component {
  state = {
    location: "",
    selectedPaymentOption: "credit",
    couponValidateMessage: "",
    coupon: {},
    showLoginForm: false,
  };

  initialFormValues = {
    term: "",
    selectedSuburb: "",
    location: "",
    classId: this.props.match.params.classId
      ? { value: this.props.match.params.classId }
      : {},
    parentFirstName: "",
    parentLastName: "",
    parentPhone: "",
    parentEmail: "",
    stripeId: "",
    paymentType: "credit",
    accountHolderName: "",
    termsAndConditions: false,
    address: "",
    suburb: "",
    postcode: "",
    state: "",
    paymentOption: "",
    paymentOptionValidation: false,
    childs: [
      {
        ...CHILD_FIELDS,
        isSizeAndQuantityRequired:
          this.props.match.params.business === "quest"
            ? //  &&
            // this.props.match.url.includes("/weekly/")
            true
            : false,
        size: "",
        isQuestWeekly:
          this.props.match.params.business === "quest"
            ? // &&
            // this.props.match.url.includes("/weekly/")
            true
            : false,
      },
    ],
    isQuestWeekly:
      this.props.match.params.business === "quest"
        ? // &&
        // this.props.match.url.includes("/weekly/")
        true
        : false,
    size: "",
  };

  componentWillMount = () => {
    const { dispatch, match, user } = this.props;

    dispatch({
      type: "locations/GET_LIST_BY_UUID",
      payload: {
        uuid: match.params.uuid,
        tag: match.params.tag,
        business: match.params.business,
      },
    });
    
    dispatch({
      type: "age/GET_LIST",
    });

    dispatch({
      type: "settings/GET_PUBLIC_SETTING",
      payload: { uuid: match.params.uuid, business: match.params.business },
    });

    dispatch({
      type: "settings/GET_SETTING_FOR_PUBLIC",
      payload: { business: match.params.business },
    });

    dispatch({
      type: "terms/GET_LIST",
    });

    if (match.params.classId) {
      dispatch({
        type: "classes/GET_SELECTED",
        payload: { classId: match.params.classId },
      });
    }

    if (user && user.roleId.name === "parent") {
      dispatch({
        type: "students/GET_STUDENTS_BY_PARENT",
        parentId: user._id,
      });
    }

    if (match.params.tag || match.params.classId || match.params.location) {
      dispatch({
        type: "locations/GET_LIST_BY_UUID",
        payload: {
          uuid: match.params.uuid,
          tag: match.params.tag,
          business: match.params.business,
        },
      });
    }

    if (match.params.location) {
      dispatch({
        type: "classes/GET_CLASSES_BY_LOCATION",
        payload: {
          locationId: match.params.location,
          uuid: match.params.uuid,
          type: "weekly",
          business: match.params.business,
        },
      });
    }
  };

  onTermChangeHandler = (value) => {
    const { dispatch, match } = this.props;

    dispatch({
      type: "locations/GET_LIST_BY_UUID",
      payload: {
        uuid: match.params.uuid,
        tag: match.params.tag,
        business: match.params.business,
        term: value,
      },
    });
  };

  onEmailChangeHandler = (e) => {
    const { match } = this.props;

    baseApi
      .post(`/auth/validate`, {
        email: e.target.value.toLowerCase(),
        business: match.params.business,
      })
      .then((response) => {
        this.setState({
          message: response.data.message,
          exist: false,
          error: false,
        });
      })
      .catch((error) => {
        if (error.response.data.message === "Invalid email") {
          return this.setState({
            message: error.response.data.message,
            exist: false,
            error: true,
          });
        }

        this.setState({
          message: error.response.data.message,
          exist: true,
          error: true,
        });
      });

    this.setState({ email: e.target.value });
  };

  onCouponChangeHandler = (e) => {
    const { dispatch } = this.props;

    baseApi
      .post(`/coupon/validate`, { coupon: e.target.value })
      .then((result) => {
        this.setState({
          couponValidateMessage: "Coupon Applied",
          coupon: result.data,
        });
        dispatch({
          type: "coupon/VALIDATE_COUPON",
          payload: { coupon: e.target.value },
        });
      })
      .catch((error) => {
        this.setState({
          couponValidateMessage: "Invalid Coupon!",
          coupon: {},
        });
      });
  };

  reRenderHandler = () => {
    const { history } = this.props;
    history.push(history.location.pathname);
  };

  onChangePaymentOptionHandler = (e) => {
    this.setState({ selectedPaymentOption: e.target.value });
  };

  selectedLocationHandler = (value, term) => {
    const { dispatch, match, history } = this.props;

    if (value) {
      this.setState({ location: value });
    } else {
      this.setState({ location: "" });
    }

    if (term) {
      dispatch({
        type: "classes/GET_CLASSES_BY_LOCATION",
        payload: {
          locationId: value,
          uuid: match.params.uuid,
          type: "weekly",
          tag: match.params.tag,
          business: match.params.business,
          // term,
        },
      });
    } else {
      dispatch({
        type: "classes/GET_CLASSES_BY_LOCATION",
        payload: {
          locationId: value,
          uuid: match.params.uuid,
          type: "weekly",
          tag: match.params.tag,
          business: match.params.business,
        },
      });
    }

    // if (
    //   match.url.includes("weekly") &&
    //   !match.params.venue &&
    //   !match.params.tag &&
    //   !match.params.classId
    // ) {
    //   history.push(
    //     `/${match.params.uuid}/${value}/weekly/${match.params.business}`
    //   );
    // }
  };

  render() {
    const {
      setting,
      classesByLocation,
      locations,
      dispatch,
      match,
      show,
      products,
      students,
      history,
      user,
      term,
      terms,
      classesByLocationLoading,
      ages,
      questSetting,
      gingerSetting,
    } = this.props;
    const { couponValidateMessage, coupon, showLoginForm } = this.state;

    let stripePromise;
    if (setting && setting.stripe_publishable_key) {
      stripePromise = loadStripe(
        setting.stripe_publishable_key ? setting.stripe_publishable_key : ""
      );
    }

    const selectedClass = selectedClassHelper({
      classId: match.params.classId,
      classes: classesByLocation,
    });

    const onClickLogout = () => {
      localStorage.clear("authToken");

      window.location.reload();
    };

    return (
      <>
        <Modal
          show={show}
          onHide={() =>
            dispatch({
              type: "enrolments/HIDE_MODAL",
            })
          }
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Login</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <LoginForm
              reRenderHandler={this.reRenderHandler}
              history={history}
              user={user}
              match={match}
            />
          </Modal.Body>
        </Modal>
        <div className="row ">
          <div
            className="col-md-12 col-sm-12"
          // style={{ margin: "auto", padding: "20px" }}
          >
            {showLoginForm ? (
              <div style={{ width: 600, margin: "auto", marginTop: 10 }}>
                <h4>Login</h4>
                <br />
                <LoginForm
                  reRenderHandler={this.reRenderHandler}
                  history={history}
                  user={user}
                  match={match}
                  showCancel
                  onCancel={() => this.setState({ showLoginForm: false })}
                />
              </div>
            ) : (
              <>
                {setting === null ? (
                  <>
                    <Elements stripe={loadStripe("")}>
                      <EnrolmentForm
                        ages={ages}
                        classes={
                          classesByLocation &&
                          classesByLocation.length &&
                          classesByLocation
                            .filter(
                              (selectedClass) =>
                                selectedClass.type === "weekly" &&
                                selectedClass.status === "Scheduled" &&
                                selectedClass.business === match.params.business
                            )
                            .map((selectedClass) => {
                              return {
                                ...selectedClass,
                                startTime: moment(
                                  selectedClass.from,
                                  "DD-MM-YYYY"
                                ).format("LL"),
                                endTime: moment(
                                  selectedClass.to,
                                  "DD-MM-YYYY"
                                ).format("LL"),
                              };
                            })
                        }
                        initialFormValues={
                          user &&
                            user.roleId.name === "parent" &&
                            user.business === match.params.business
                            ? {
                              ageGroup: "all",
                              term: "",
                              selectedSuburb: "",
                              location: "",
                              classId: match.params.classId
                                ? { value: match.params.classId }
                                : {},
                              parentFirstName: user.firstName,
                              parentLastName: user.lastName,
                              parentPhone: user.phone,
                              parentEmail: user.email,
                              stripeId: "",
                              paymentType: "credit",
                              accountHolderName: "",
                              termsAndConditions: false,
                              address: user.address,
                              suburb: user.suburb,
                              postcode: user.postcode,
                              state: user.state,
                              paymentOption:
                                selectedClass?.payment?.length === 1
                                  ? selectedClass.payment.includes("fixed")
                                    ? "full"
                                    : selectedClass.payment.includes("term")
                                      ? "term"
                                      : selectedClass.payment.includes(
                                        "monthly"
                                      )
                                        ? "monthly"
                                        : ""
                                  : "",
                              studentIds: [],
                              childs: [],
                              paymentOptionValidation: false,
                              size: "",
                              isQuestWeekly:
                                this.props.match.params.business === "quest"
                                  ? //  &&
                                  // this.props.match.url.includes("/weekly/")
                                  true
                                  : false,
                              isQuestWeekly:
                                this.props.match.params.business === "quest"
                                  ? // &&
                                  // this.props.match.url.includes("/weekly/")
                                  true
                                  : false,
                            }
                            : {
                              ageGroup: "all",
                              ...this.initialFormValues,
                              paymentOption:
                                selectedClass?.payment?.length === 1
                                  ? selectedClass.payment.includes("fixed")
                                    ? "full"
                                    : selectedClass.payment.includes("term")
                                      ? "term"
                                      : selectedClass.payment.includes(
                                        "monthly"
                                      )
                                        ? "monthly"
                                        : ""
                                  : "",
                            }
                        }
                        locations={locations.filter(
                          (location) => location.status === "active"
                        )}
                        products={products}
                        dispatch={dispatch}
                        parent={user && user.roleId.name === "parent"}
                        selectedLocation={match.params.venue}
                        onChangePaymentOptionHandler={
                          this.onChangePaymentOptionHandler
                        }
                        selectedPaymentOption={this.state.selectedPaymentOption}
                        onChangeHandler={this.onEmailChangeHandler}
                        selectedEmail={this.state.email}
                        message={this.state.message}
                        exist={this.state.exist}
                        error={this.state.error}
                        showModal={() =>
                          dispatch({
                            type: "enrolments/SHOW_MODAL",
                          })
                        }
                        {...this.props}
                        selectedLocationHandler={this.selectedLocationHandler}
                        stripePublishableKey={
                          setting && setting.stripe_publishable_key
                        }
                        students={students}
                        term={terms?.find((term) => term?.status === "current")}
                        setSelected={(values) =>
                          this.setState({ selected: values })
                        }
                        setShowLoginForm={() =>
                          this.setState({ showLoginForm: true })
                        }
                        onClickLogout={onClickLogout}
                        onTermChangeHandler={this.onTermChangeHandler}
                        terms={terms}
                        classesByLocationLoading={classesByLocationLoading}
                        questSetting={questSetting}
                        gingerSetting={gingerSetting}
                        business={match.params.business}
                      />
                    </Elements>
                  </>
                ) : setting &&
                  setting.stripe_publishable_key &&
                  stripePromise ? (
                  <Elements stripe={stripePromise}>
                    <EnrolmentForm
                      ages={ages}
                      classes={
                        classesByLocation &&
                        classesByLocation.length &&
                        classesByLocation
                          .filter(
                            (selectedClass) =>
                              selectedClass.type === "weekly" &&
                              selectedClass.status === "Scheduled" &&
                              selectedClass.business === match.params.business
                          )
                          .map((selectedClass) => {
                            return {
                              ...selectedClass,
                              startTime: moment(
                                selectedClass.from,
                                "DD-MM-YYYY"
                              ).format("LL"),
                              endTime: moment(
                                selectedClass.to,
                                "DD-MM-YYYY"
                              ).format("LL"),
                            };
                          })
                      }
                      locations={locations.filter(
                        (location) => location.status === "active"
                      )}
                      products={products}
                      dispatch={dispatch}
                      selectedLocation={match.params.venue}
                      onChangePaymentOptionHandler={
                        this.onChangePaymentOptionHandler
                      }
                      selectedPaymentOption={this.state.selectedPaymentOption}
                      onChangeHandler={this.onEmailChangeHandler}
                      selectedEmail={this.state.email}
                      message={this.state.message}
                      exist={this.state.exist}
                      changeEmailMessage={() => this.setState({ exist: false })}
                      error={this.state.error}
                      showModal={() =>
                        dispatch({
                          type: "enrolments/SHOW_MODAL",
                        })
                      }
                      {...this.props}
                      selectedLocationHandler={this.selectedLocationHandler}
                      stripePublishableKey={
                        setting && setting.stripe_publishable_key
                      }
                      parent={
                        user &&
                        user.roleId.name === "parent" &&
                        user.business === match.params.business
                      }
                      initialFormValues={
                        user &&
                          user.roleId.name === "parent" &&
                          user.business === match.params.business
                          ? {
                            ageGroup: "all",
                            searchBySuburbOrPostcode: false,
                            term: "",
                            selectedSuburb: "",
                            location: "",
                            classId: match.params.classId
                              ? { value: match.params.classId }
                              : {},
                            parentFirstName: user.firstName,
                            stripe_customer_id: user.stripe_customer_id,
                            parentLastName: user.lastName,
                            parentPhone: user.phone,
                            parentEmail: user.email,
                            stripeId: "",
                            paymentType: "credit",
                            accountHolderName: "",
                            termsAndConditions: false,
                            address: user.address,
                            suburb: user.suburb,
                            postcode: user.postcode,
                            state: user.state,
                            paymentOption:
                              selectedClass?.payment?.length === 1
                                ? selectedClass.payment.includes("fixed")
                                  ? "full"
                                  : selectedClass.payment.includes("term")
                                    ? "term"
                                    : selectedClass.payment.includes("monthly")
                                      ? "monthly"
                                      : ""
                                : "",
                            studentIds: [],
                            childs: [],
                            paymentOptionValidation: false,
                            size: "",
                            isQuestWeekly:
                              this.props.match.params.business === "quest"
                                ? //  &&
                                // this.props.match.url.includes("/weekly/")
                                true
                                : false,
                          }
                          : {
                            ageGroup: "all",
                            ...this.initialFormValues,
                            paymentOption:
                              selectedClass?.payment?.length === 1
                                ? selectedClass.payment.includes("fixed")
                                  ? "full"
                                  : selectedClass.payment.includes("term")
                                    ? "term"
                                    : selectedClass.payment.includes("monthly")
                                      ? "monthly"
                                      : ""
                                : "",
                            searchBySuburbOrPostcode: false,
                          }
                      }
                      students={students}
                      onCouponChangeHandler={this.onCouponChangeHandler}
                      couponValidateMessage={couponValidateMessage}
                      changeCouponValidationMessage={() =>
                        this.setState({ couponValidateMessage: "", coupon: {} })
                      }
                      // changeEmailMessage={() => this.setState({ exist: false })}
                      coupon={coupon}
                      term={terms?.find((term) => term?.status === "current")}
                      // selectedLessons={
                      //   match.params.classId &&
                      //   selectedClass?.payment?.length === 1
                      //     ? parseLessonsNames({
                      //         classId: match.params.classId,
                      //         classes: classesByLocation,
                      //         term,
                      //         paymentOption:
                      //           selectedClass?.payment?.length === 1
                      //             ? selectedClass.payment.includes("fixed")
                      //               ? "full"
                      //               : selectedClass.payment.includes("term")
                      //               ? "term"
                      //               : selectedClass.payment.includes("monthly")
                      //               ? "monthly"
                      //               : ""
                      //             : "",
                      //       })?.sessions?.map((session) => ({
                      //         value: session?._id,
                      //         label: session?.date,
                      //       }))
                      //     : []
                      // }
                      setShowLoginForm={() =>
                        this.setState({ showLoginForm: true })
                      }
                      onClickLogout={onClickLogout}
                      onTermChangeHandler={this.onTermChangeHandler}
                      terms={terms}
                      classesByLocationLoading={classesByLocationLoading}
                      questSetting={questSetting}
                      gingerSetting={gingerSetting}
                      business={match.params.business}
                    />
                  </Elements>
                ) : (
                  <div style={{ height: "800px" }}>
                    <div className="text-center" style={{ marginTop: "400px" }}>
                      <div className="spinner-border" role="status"></div>{" "}
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    show: state.enrolments.show,
    locations: state.locations.selectedLocations,
    loadingLocations: state.locations.loadingLocations,
    setting: state.settings.publicSetting,
    classesByLocation: state.classes.classesByLocation,
    students: state.students.studentsByParents,
    products: state.products.publicProducts,
    selectedClass: state.classes.selected,
    user: state.auth.user,
    terms: state.terms.list,
    classesByLocationLoading: state.classes.classesByLocationLoading,
    ages: state.age.age,
    questSetting: state.settings.questSetting,
    gingerSetting: state.settings.gingerSetting,
  };
};

export default connect(mapStateToProps)(SecondEnrolmentPage);
